// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table.table input.input[data-v-50f32c58] {\n  padding: 3px;\n  height: 27px;\n  font-size: 1rem;\n}", ""]);
// Exports
module.exports = exports;
